// privateBookingCheckin.js — toggles check-in status for a Private lesson booking.
// Shared by the Dashboard's quick roster (PrivateBookingList.vue), the "จัดการการจอง
// Private" grid (PrivateBookingManagement.vue), and the coach-schedule Private card
// (GroupingSheet.vue) — all three call the same two endpoints. The backend allows
// head/admin (any booking) or the assigned coach (own bookings only).

import axios from 'axios';

export async function togglePrivateBookingCheckin(baseURL, token, privatebookingid, wasCheckedIn) {
  const endpoint = wasCheckedIn ? '/undoCheckinPrivateBookingByAdmin' : '/checkinPrivateBookingByAdmin';
  const response = await axios.post(baseURL + endpoint, { privatebookingid }, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
}
